function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import _ from 'underscore';
import Collection from './collection';
import ClickableImageRegion from './clickable_image_region';
var DEFAULT_NAME_REGEX = /^Region (\d+)$/;

var ClickableImageRegions = /*#__PURE__*/function (_Collection) {
  _inheritsLoose(ClickableImageRegions, _Collection);

  function ClickableImageRegions() {
    return _Collection.apply(this, arguments) || this;
  }

  var _proto = ClickableImageRegions.prototype;

  _proto.isValueCorrect = function isValueCorrect(value) {
    // 'correct' is on its way to being deprecated. 'correct_response' will be the non-deprecated version (as of March 2019)
    return this.collidableRegions(this).some(function (region) {
      return (region.get('correct') || region.get('correct_response')) && region.contains(value);
    });
  }
  /*
   * first, try to move the region to a valid position
   * by resolving any overlaps. Then, check to make sure
   * it hasn't been moved on top of another region or
   * outside the bounds of the container image
   */
  ;

  _proto.addValid = function addValid(region) {
    region.resolveOverlaps(this);
    var invalid = region.outsideContainer() || this.collidableRegions(region).some(function (r) {
      return region.overlaps(r);
    });

    if (!invalid) {
      this.add(region);
    }
  }
  /*
   * Regions to check for overlap.
   * Filter out region that matches the
   * passed in one.
   * Filter out regions that have been
   * marked for deletion on the server
   */
  ;

  _proto.collidableRegions = function collidableRegions(region) {
    var regions = this.filter(function (r) {
      return region !== r && region.get('_destroy') !== 1 && r.get('_destroy') !== 1;
    });
    return new ClickableImageRegions(regions);
  };

  _proto.highestResult = function highestResult() {
    return _.max(this.pluck('results_count'));
  };

  _proto.hasAlphaNumericKeyword = function hasAlphaNumericKeyword() {
    return this.any(function (option) {
      return option.isKeywordAlphaNumeric();
    });
  };

  _proto.hasCorrect = function hasCorrect() {
    // 'correct' is on its way to being deprecated. 'correct_response' will be the non-deprecated version (as of March 2019)
    return this.any(function (option) {
      return option.get('correct') || option.get('correct_response');
    });
  };

  _proto.getNextName = function getNextName() {
    var length = 0;
    var maxRegionNumber = 0;
    this.each(function (region) {
      if (!region.isOtherRegion()) {
        length += 1;
        var match = DEFAULT_NAME_REGEX.exec(region.getName());

        if (match) {
          maxRegionNumber = Math.max(maxRegionNumber, parseInt(match[1]));
        }
      }
    });
    var newNumber = Math.max(length, maxRegionNumber) + 1;
    return "Region " + newNumber;
  };

  _createClass(ClickableImageRegions, [{
    key: "model",
    get: function get() {
      return ClickableImageRegion;
    }
  }]);

  return ClickableImageRegions;
}(Collection);

export { ClickableImageRegions as default };